import { IsOptional, IsString, Matches } from 'class-validator';

export const HH_MM_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

/**
 * Solo il FORMATO qui: la coppia (entrambe le estremità o nessuna) e
 * l'ordine from < to sono validati nel service con messaggi localizzati
 * (`error.notificationWindow.*`) — un vincolo DTO con messaggio hardcoded
 * oscurerebbe le traduzioni al client.
 */
export class UpdateNotificationWindowDto {
  /// Inizio della fascia oraria in cui gli avvisi possono arrivare ("HH:mm").
  /// Null insieme a `to` = nessuna limitazione.
  @IsOptional()
  @IsString()
  @Matches(HH_MM_PATTERN, { message: 'from must be HH:mm' })
  from!: string | null;

  /// Fine della fascia oraria ("HH:mm", esclusa). Null insieme a `from` =
  /// nessuna limitazione.
  @IsOptional()
  @IsString()
  @Matches(HH_MM_PATTERN, { message: 'to must be HH:mm' })
  to!: string | null;
}
